var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "listItem" }, [
    _vm.upsellDescriptionText.length
      ? _c("div", { staticClass: "upsellHeader" }, [
          _vm._v(_vm._s(_vm.upsellDescriptionText)),
        ])
      : _vm._e(),
    _c("div", { staticClass: "upsellContentBox" }, [
      _c("div", { staticClass: "itemThumbnail" }, [
        _c("img", { attrs: { src: _vm.offeringImage } }),
      ]),
      _c("div", { staticClass: "itemInfo" }, [
        _c("span", { staticClass: "itemName" }, [
          _vm._v(_vm._s(_vm.offeringName)),
        ]),
        _vm.offeringDescriptionLineOne.length
          ? _c("span", { staticClass: "itemDescription" }, [
              _vm._v(_vm._s(_vm.offeringDescriptionLineOne)),
            ])
          : _vm._e(),
        _vm.offeringDescriptionLineTwo.length
          ? _c("span", { staticClass: "itemDescription" }, [
              _vm._v(_vm._s(_vm.offeringDescriptionLineTwo)),
            ])
          : _vm._e(),
        _c("span", { staticClass: "itemPrice" }, [
          _vm._v("+ " + _vm._s(_vm.priceLabel)),
        ]),
      ]),
      _c("div", { staticClass: "itemQuantity" }, [
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.internalQuantity,
                expression: "internalQuantity",
              },
            ],
            staticClass: "selectBox",
            on: {
              change: function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.internalQuantity = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
            },
          },
          [
            _c("option", { attrs: { value: "0" } }, [_vm._v("0")]),
            _vm._l(_vm.maxQuantity, function (n) {
              return _c("option", { key: n, domProps: { value: n } }, [
                _vm._v(_vm._s(n)),
              ])
            }),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }